/** Zero-hours fallback used when a booking has no scheduled hours recorded. */
export const NO_SCHEDULED_HOURS = {
  monday: 0,
  tuesday: 0,
  wednesday: 0,
  thursday: 0,
  friday: 0,
  saturday: 0,
  sunday: 0,
};
